export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  filter:{searchText:string, status:number};
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  icdDes: string;
  icdId: number;
  icdName: string;
  icdCode: string;
  icdCreatedByDate: string;
  icdClinicId: number;
  icdStatus: number;
  icdVersion: string;
};

export type MasterDataType = {
  icdId: number | null;
  icdCode: string;
  icdClinicId: number;
  icdCreatedByDate: string;
  icdCreatedById: number;
  icdDescription: string;
  icdName: string;
  icdStatus: number;
  icdVersion: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  icdCode: string;
  icdName: string;
  icdVersion: string;
  icdDescription: string;
  status: number;
};

export const initialFormData: MasterFormDataType = {
  icdCode: "",
  icdName: "",
  icdVersion: "",
  icdDescription: "",
  status: 1,
};

export type UploadedListType = {
  icdDescription: string | null;
  icdStatus: number;
  icdVersion: string;
  icdName: string;
  icdCode: string;
  icdId: number;
};
